(function (root) {
  'use strict';

  var RULES = ['down', 'wilson', 'confirm', 'neutral_between', 'neutral_confirm'];
  var BASES = ['same', 'boot', 'measured', 'sneaker', 'unsure'];

  function recommend(product, answers) {
    answers = answers || {};
    var notes = [];
    var width = answers.width === 'EE' ? 'EE' : 'D';
    var confirm = answers.width === 'unsure';
    var variants = product && Array.isArray(product.variants) ? product.variants : [];

    function note(key) {
      if (notes.indexOf(key) === -1) notes.push(key);
    }

    function result(kind, sizes, reasonKey, extraConfirm, error) {
      var configured = sizes.map(function (size) {
        return variants.some(function (variant) {
          return variant.size === size && variant.width === width;
        });
      });
      if (configured.indexOf(false) !== -1 && kind !== 'help') {
        note('variant_gap');
        extraConfirm = true;
      }
      var alternative = null;
      var primaryReasonKey = reasonKey;
      if (kind === 'range' && sizes.length === 2) {
        var lower = Math.min.apply(null, sizes), upper = Math.max.apply(null, sizes);
        var room = answers.concern === 'instep' || answers.concern === 'orthotics' || answers.socks === 'thick' || answers.preference === 'roomy';
        var neutral = product.rule === 'confirm' || product.rule === 'neutral_confirm' || (answers.basis === 'measured' && product.rule === 'neutral_between');
        var primary = room || neutral ? upper : lower;
        primaryReasonKey = room ? (answers.concern === 'instep' ? 'pick_instep' : answers.concern === 'orthotics' ? 'pick_orthotics' : answers.socks === 'thick' ? 'pick_socks' : 'pick_room') : neutral ? 'pick_neutral' : 'pick_close';
        var other = primary === lower ? upper : lower;
        alternative = {size:other,width:width,configured:variants.some(function(v){return v.size===other&&v.width===width;}),reasonKey:primary===upper?'alternate_smaller':'alternate_larger'};
        sizes=[primary];configured=[variants.some(function(v){return v.size===primary&&v.width===width;})];kind='single';
      }
      var value = {
        kind: kind,
        sizes: sizes,
        width: width,
        reasonKey: reasonKey,
        primaryReasonKey: primaryReasonKey,
        alternative: alternative,
        notes: notes.slice(),
        confirm: Boolean(confirm || extraConfirm),
        configured: configured
      };
      if (error) value.error = error;
      return value;
    }

    if (!product || RULES.indexOf(product.rule) === -1 || !variants.length) {
      return result('help', [], 'unsupported_product', true, 'unsupported_product');
    }
    if (BASES.indexOf(answers.basis) === -1) {
      return result('help', [], 'invalid_input', true, 'invalid_basis');
    }
    if (answers.basis === 'sneaker') {
      note('no_sneaker_conversion');
      return result('help', [], 'sneaker_reference', true);
    }
    if (answers.basis === 'unsure') {
      return result('help', [], 'no_reference', true);
    }
    var size = answers.size;
    if (typeof size !== 'number' || !Number.isFinite(size) || size < 1 || size > 25 || size * 2 !== Math.round(size * 2)) {
      return result('help', [], 'invalid_input', true, 'invalid_size');
    }
    if (['D', 'EE', 'unsure'].indexOf(answers.width) === -1) {
      return result('help', [], 'invalid_input', true, 'invalid_width');
    }
    if (answers.width === 'unsure') note('width_unsure');

    // A comfortable same-style pair takes precedence over every merchandising rule.
    if (answers.basis === 'same') {
      if (answers.sameComfortable !== true) {
        return result('help', [], 'same_not_comfortable', true);
      }
      note('same_size_kept');
      if (product.rule === 'confirm') note('color_fit_check');
      return result('single', [size], 'same_style', product.rule === 'confirm');
    }

    if (answers.concern === 'forefoot') {
      width = 'EE';
      note('width_ee');
    }
    if (answers.concern === 'instep') note('instep_check');
    if (answers.concern === 'orthotics') note('orthotics_check');
    if (answers.socks === 'thick') note('thick_socks_check');
    var extraRoom = answers.concern === 'instep' || answers.concern === 'orthotics' || answers.socks === 'thick' || answers.preference === 'roomy';
    if (answers.concern === 'instep' || answers.concern === 'orthotics') confirm = true;

    // A measured foot is not the same baseline as a comfortable shoe label.
    if (answers.basis === 'measured') {
      note('measured_tentative');
      if (product.rule === 'confirm') {
        note('color_fit_check');
        return result('range', [size - 0.5, size], 'measured_confirm', true);
      }
      return result('range', [size - 0.5, size], 'measured_range', true);
    }

    note('starting_point');
    var between = answers.between === true;
    var lower = size - 0.5;

    if (product.rule === 'confirm') {
      note('color_fit_check');
      return result(between ? 'range' : 'single', between ? [lower, size] : [size], 'color_confirm', true);
    }
    if (product.rule === 'neutral_confirm') {
      note('limited_evidence');
      return result(between ? 'range' : 'single', between ? [lower, size] : [size], 'limited_confirm', true);
    }

    var down = product.rule === 'down' || between || (product.rule === 'wilson' && answers.socks === 'thin');
    if (down && extraRoom) {
      return result('range', [lower, size], 'room_confirm', true);
    }
    if (down) {
      var reason = between ? 'between_smaller' : (product.rule === 'wilson' ? 'wilson_conditional' : 'size_down');
      return result('single', [lower], reason, false);
    }
    return result('single', [size], 'usual_size', false);
  }

  function compare(source, target, answers) {
    if (source.handle === target.handle || answers.basis !== 'same') return recommend(target, answers);
    if (!answers.sameComfortable) return recommend(target, answers);
    var shift = source.rule === 'down' || (source.rule === 'wilson' && answers.socks === 'thin') ? 0.5 : 0;
    var translated = Object.assign({}, answers, {basis:'boot',size:Number(answers.size)+shift,between:false});
    var value = recommend(target, translated);
    value.confirm = true;
    value.notes.push('cross_style_estimate');
    return value;
  }
  var api = Object.freeze({ recommend: recommend, compare: compare });
  root.HELMFit = api;
  if (typeof module === 'object' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
